import React, {useCallback} from 'react';
import {SIDEBAR_WIDTH} from 'constants/sidebar-sizes.js';
import {setViewportPosition} from 'actions/index.js';
export const useViewport = ({sequencerEngine}) => {
    const handleScroll = useCallback((x,y, sizeRef) => {
        return;
        let {position, mainScrollRef} = sequencerEngine.state.spatial;
        let {width, height} = sizeRef.current;
        let {innerWidth, innerHeight} = window;
        let {scrollLeft, scrollTop} = mainScrollRef.current;


        let xOff = x - scrollLeft - (innerWidth - 2*SIDEBAR_WIDTH);
        let yOff = y - scrollTop - (innerHeight - 45);

        if (xOff > 0 || yOff > 0) {
            mainScrollRef.current.scrollTo(scrollLeft + xOff, scrollTop + yOff);
        }
    }, []);

    return {handleScroll};
};
